/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Localized from '../../../../shared/components/Localized';
import { StandardIcon } from '../../../components/SVGIcon';

import styles from '../../../styles';

const LeftWrapper = styled.div`
  flex: 1 1 0%;
  min-width: 0;
  display: flex;
`;

const Wrapper = styled.div`
  ${styles.borders.card}
  padding: 1rem;
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
  background-color: ${styles.colors.linkWater};

  display: flex;

  @media (max-width: 767px) {
    padding: 1rem 1.25rem;
    margin-left: 0;
    margin-right: 0;
    border-radius: 0;
  }
`;

const Icon = styled.div`
  padding-right: 1rem;
`;

const Label = styled.div`
  ${styles.fonts.headingLabelCaps}
`;

const Heading = styled.div`
  ${styles.fonts.headingMedium}
`;

const Banner = ({ instance, instanceAlias, children }) => (
  <Wrapper>
    <LeftWrapper>
        <Icon>
          <StandardIcon
            icon='orders'
            bgColor={ styles.colors.turquoise }
            size='3rem'
            round />
        </Icon>
        <div>
          <Label>
            <Localized modelName='root' modelAttribute='header' modelKey='instance' />
          </Label>
          <Heading>
            { instanceAlias ? (instanceAlias.toUpperCase() + ' | ') : null }
            <Localized modelName='instance' modelAttribute='label' modelKey={instance.key} />
          </Heading>
        </div>
      </LeftWrapper>
    { children }

  </Wrapper>
);

Banner.propTypes = {
  instance: PropTypes.shape({
    key: PropTypes.string,
  })
};

export default Banner;
